import { memo } from 'react'
import { parseDateString } from '../../utils/dateUtils'

/**
 * Format date as "Sun 22 February 2026" — same format as TimelineDateGroup headers.
 */
function formatDateHeader(dateString) {
  const dateObj = parseDateString(dateString)
  const dayName = dateObj.toLocaleDateString('en-GB', { weekday: 'short' })
  const datePart = dateObj.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
  return `${dayName} ${datePart}`
}

/**
 * FloatingDateHeader - iOS-style sticky section header.
 *
 * Zero-height sticky wrapper so it overlays virtualised content.
 * Uses transform to:
 *   - Slide out above viewport when at the top (avoids duplicating first group header)
 *   - Push up when the next section's group header approaches (iOS push effect)
 */
const FloatingDateHeader = memo(function FloatingDateHeader({ date, totalRevenue = 0, totalKg = 0, pushOffset = 0 }) {
  if (!date) return null

  return (
    <div
      className="sticky top-0 z-20"
      style={{
        height: 0,
        transform: pushOffset < 0 ? `translateY(${pushOffset}px)` : undefined,
        willChange: pushOffset < 0 ? 'transform' : undefined,
      }}
    >
      <div className="bg-white border-b px-6 py-1.5 flex justify-between items-center">
        <span className="text-xs font-semibold text-muted-foreground">
          {formatDateHeader(date)}
        </span>
        <span className="text-xs font-semibold text-muted-foreground">
          £{totalRevenue.toFixed(2)}  {totalKg.toFixed(1)}kg
        </span>
      </div>
    </div>
  )
})

export default FloatingDateHeader
